<div class="cx-loader">
  <!-- Particles: delayed, part of "later animations" -->
  <div class="cx-particles">
    <div
      class="particle"
      *ngFor="let p of particles"
      [style.--x]="p.x + '%'"
      [style.--y]="p.y + '%'"
      [style.--size]="p.size + 'px'"
      [style.--delay]="p.delay + 's'"
      [style.--duration]="p.duration + 's'"
    ></div>
  </div>

  <!-- Card: immediately visible snapshot -->
  <div class="cx-card">
    <!-- Orb: delayed glow (behind logo) -->
    <div class="cx-orb"></div>



    <!-- ② LOGO with rings — logo visible immediately, rings spin after delay -->
    <div class="cx-logo-wrap">
      <div class="cx-ring-wrap cx-ring-wrap-1">
        <div class="cx-ring cx-ring-1"></div>
      </div>
      <div class="cx-ring-wrap cx-ring-wrap-2">
        <div class="cx-ring cx-ring-2"></div>
      </div>
      <div class="cx-ring-wrap cx-ring-wrap-3">
        <div class="cx-ring cx-ring-3"></div>
      </div>
      <div class="cx-logo-circle">
        <img
          src="../../../assets/loading.png"
          alt="Aluguloo"
          class="cx-logo-img"
        />
      </div>
    </div>

    <!-- ③ PROGRESS BAR — visible immediately, shimmer starts after delay -->
    <div class="cx-progress-track">
      <div class="cx-progress-bar"></div>
    </div>

    <!-- ⑥ Status Message -->
    <div class="cx-status" *ngIf="myInput">
      {{ myInput }}
    </div>
  </div>
</div>
